<template>
  <div class="header p-0">
    <nav class="navbar fixed-top text-center">
      <a href="/" class="navbar-brand">
        <picture class="pointer">
          <source srcset="../assets/logo.webp" type="image/webp">
          <source srcset="../assets/logo.png" type="image/png">
          <img src="../assets/logo.png" height="30" alt="">
        </picture>
      </a>
      <div>
        <span @click="state.lang='eng'" :class="['lang',' mr-4', 'button', {'active': state.lang==='eng'}]">eng</span> | <span @click="state.lang='srb'" :class="['lang',' mr-5', 'ml-4','button', {'active': state.lang==='srb'}]">srb</span>
        <button @click="menuToggle()" class="navbar-toggler drotate" type="button" id="mainMenuButton">
            <span class="navbar-toggler-icon"><awesome-icon class="icon mt-n2" :icon="['fas', 'bars']" size="2x"></awesome-icon></span>
        </button>
      </div>
    </nav>
    <div id="mainMenu" :class="['navbar-collapse', 'collapse', 'text-center', {'show': showMenu}]">
        <button @click="showMenu=false" :class="['navbar-toggler', {'animrotate': showMenu}]" type="button">
            <span class="navbar-toggler-icon">X</span>
        </button>
        <ul class="navbar-nav">
          <li class="nav-item nav-top">
              <a class="nav-link" href="#showreel">
                <picture class="pointer">
                  <source srcset="../assets/logo.webp" type="image/webp">
                  <source srcset="../assets/logo.png" type="image/png">
                  <img src="../assets/logo.png" height="30" class="d-inline-block align-top" alt="">
                </picture>
              </a>
          </li>
        </ul>
        <ul class="navbar-nav nav-middle">
            <li class="nav-item">
                <a :class="['nav-link', {'active': clicked=='showreel'}]" @click="clicked='showreel'" href="#showreel">{{state.translation.menu.showreel}}</a>
            </li>
            <li class="nav-item">
                <a :class="['nav-link', {'active': clicked=='services'}]" @click="clicked='services'" href="#services">{{state.translation.menu.ourservices}}</a>
            </li>
            <li class="nav-item">
                <a :class="['nav-link', {'active': clicked=='process'}]" @click="clicked='process'" href="#process">{{state.translation.menu.workingprocess}}</a>
            </li>
            <li class="nav-item">
                <a :class="['nav-link', {'active': clicked=='technologies'}]" @click="clicked='technologies'" href="#technologies">{{state.translation.menu.technologies}}</a>
            </li>
            <li class="nav-item">
                <a :class="['nav-link', {'active': clicked=='contact'}]" @click="clicked='contact'" href="#contact">{{state.translation.menu.contact}}</a>
            </li>
        </ul>
        <div class="bottom-nav">
          <span class="lang-holder">
            <span @click="state.lang='eng'" :class="['lang',' mr-4', 'button', {'active': state.lang==='eng'}]">eng</span> | <span @click="state.lang='srb'" :class="['lang', 'ml-4','button', {'active': state.lang==='srb'}]">srb</span>
          </span>
          <div class="mt-5">
            <span class="social">
              <span class="mr-4 button"><awesome-icon class="icon mt-n2" :icon="['fab', 'facebook-f']" size="2x"></awesome-icon></span>
              <span class="mr-4 button"><awesome-icon class="icon mt-n2" :icon="['fab', 'twitter']" size="2x"></awesome-icon></span>
              <span class="mr-4 button"><awesome-icon class="icon mt-n2" :icon="['fab', 'instagram']" size="2x"></awesome-icon></span>
              <span class="mr-4 button"><awesome-icon class="icon mt-n2" :icon="['fab', 'linkedin-in']" size="2x"></awesome-icon></span>
            </span>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  metaInfo: {
      title: 'IT Fortress | Web and Mobile development and design services',
      meta: [
          {hid: 'description', name: 'description', content: 'Web dizajn, web design, administration,back end development,front end development,anrdoid applications, IOS applications,outsourcing.'},
      ]
  },
  data() {
    return {
      showMenu: false,
      clicked: 'showreel',
      state: this.$root.$data.state,
    }
  },
  mounted() {
    let self = this;
    var menu = document.getElementById('mainMenu');
    var button = document.getElementById('mainMenuButton');

    document.addEventListener('click', function(event) {
        //var isClickInside = menu.contains(event.target);
        var isClickButtonNav = button.contains(event.target);

        if (/*!isClickInside &&*/ !isClickButtonNav) {
          self.showMenu = false;
        }
    });
  },
  methods: {
    menuToggle() {
      this.showMenu=!this.showMenu
    }
  },
  watch: {
      'state.lang': function() {
        let self = this;
        this.state.languageActive = false;
        setTimeout(() => {self.loadLanguage();}, 500)
      },
  }
}
</script>
